var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHhStar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3235,
    height: 959,
    viewBox: "0 0 3235 959",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.063 0L385.073 366.229H0L311.531 592.563L192.531 958.792L504.063 732.453L815.594 958.792L696.594 592.563L1008.13 366.229H623.052L504.063 0Z",
    fill: "#26A282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1617.06 0L1498.07 366.229H1113L1424.53 592.563L1305.53 958.792L1617.06 732.453L1928.59 958.792L1809.59 592.563L2121.13 366.229H1736.05L1617.06 0Z",
    fill: "#26A282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2730.06 0L2611.07 366.229H2226L2537.53 592.563L2418.53 958.792L2730.06 732.453L3041.59 958.792L2922.59 592.563L3234.13 366.229H2849.05L2730.06 0Z",
    fill: "#26A282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHhStar3);
export default __webpack_public_path__ + "static/media/HH_Star3.b0f34e28142848a01de41dd60cba371e.svg";
export { ForwardRef as ReactComponent };